import { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";
import Lottie, { LottieRefCurrentProps } from "lottie-react";
import successAnim from "../../assets/Success.json";
import { Pages } from "../../utils";
import { useUserContext } from "../../hooks/userContext";

const REDIRECT_DELAY_MS = 5000;
const MEETING_SCHEDULED_STORAGE_KEY = "hdg_designer_meeting_scheduled";

export const DesignerMeetingSuccessPage = () => {
  const navigate = useNavigate();
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const [redirectCountdown, setRedirectCountdown] = useState(
    Math.ceil(REDIRECT_DELAY_MS / 1000)
  );
  const { user } = useUserContext();

  const handleRedirectNow = useCallback(() => {
    navigate(Pages.YOUR_HUB, { replace: true });
  }, [navigate]);

  useEffect(() => {
    // Persist that the designer has scheduled their meeting so we can disable the button in the status card
    try {
      const storageKey = `${MEETING_SCHEDULED_STORAGE_KEY}${user?.id ? `:${user.id}` : ""}`;
      localStorage.setItem(
        storageKey,
        JSON.stringify({
          scheduledAt: new Date().toISOString(),
          userId: user?.id ?? null,
        })
      );

      // Clean up legacy key so it doesn't leak across users on the same device
      if (user?.id) {
        localStorage.removeItem(MEETING_SCHEDULED_STORAGE_KEY);
      }
    } catch (error) {
    }

    const redirectTimer = setTimeout(handleRedirectNow, REDIRECT_DELAY_MS);
    const countdownInterval = setInterval(() => {
      setRedirectCountdown((prev) => (prev > 1 ? prev - 1 : 1));
    }, 1000);

    return () => {
      clearTimeout(redirectTimer);
      clearInterval(countdownInterval);
    };
  }, [handleRedirectNow]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "4rem 1rem",
        minHeight: "100vh",
        textAlign: "center",
      }}
    >
      <div style={{ width: 200, height: 200 }}>
        <Lottie
          lottieRef={lottieRef}
          animationData={successAnim}
          loop
          autoplay
        />
      </div>

      <h2
        style={{
          marginTop: 24,
          fontSize: 28,
          fontWeight: 700,
          textAlign: "center",
        }}
      >
        Meeting Scheduled
      </h2>
      <p
        style={{
          marginTop: 8,
          color: "#666",
          textAlign: "center",
          maxWidth: 500,
          margin: "8px auto",
        }}
      >
        Thanks for scheduling your vetting call. We'll review your application
        and update your status soon.
      </p>
      <p
        style={{
          marginTop: 8,
          color: "#666",
          textAlign: "center",
          fontSize: 14,
          maxWidth: 500,
          margin: "8px auto",
        }}
      >
        Redirecting you to Your Hub in {redirectCountdown} seconds.
      </p>

      <button
        onClick={handleRedirectNow}
        style={{
          marginTop: 24,
          padding: "24px 40px",
          borderRadius: 4,
          border: "1px solid #D22268",
          color: "#D22268",
          backgroundColor: "transparent",
          cursor: "pointer",
          fontWeight: 600,
        }}
      >
        Go to Your Hub
      </button>
    </div>
  );
};
